module.exports = __webpack_public_path__ + "img/meetingsclient20.8d06ecab.png";